import React from 'react';
import styled from 'styled-components';
import getHtmlFromRedactorField from '../../utils/getHtmlFromRedactorField';

const Text = styled.div`
	color: var(--text-color);
	font-family: ${({ theme }) => theme.fontFamily.mainFont};
	font-size: 18px;
	font-weight: ${({ theme }) => theme.fontWeight.thin};
	line-height: 38px;

	&.workflow {
		font-weight: ${({ theme }) => theme.fontWeight.light};
		transition: color 0.4s ease-in-out;

		@media ${({ theme }) => theme.device.w_768} {
			font-size: 13px;
			line-height: 28px;
		}

		@media ${({ theme }) => theme.device.w_1024} {
			font-size: 18px;
			line-height: 36px;
		}

		@media ${({ theme }) => theme.device.w_1440} {
			font-size: 22px;
			line-height: 40px;
		}
	}

	@media ${({ theme }) => theme.device.w_1024} {
		font-size: 22px;
		line-height: 40px;
	}
`;

const TextDescription3 = ({ className, children }) => {
	return <Text className={className} dangerouslySetInnerHTML={getHtmlFromRedactorField(children)} />;
};

export default TextDescription3;
